import React from 'react';

import useProducts from '../../hooks/useProducts';
import ProductCard from './ProductCard';

// Suggests other products in the same category, excluding the current one.
export default function RelatedProducts({ categorySlug, excludeId }) {
  const { items, loading } = useProducts({ category: categorySlug, limit: 5, sort: 'newest' });

  if (!categorySlug || loading) return null;

  const related = items.filter((p) => (p._id || p.id) !== excludeId).slice(0, 4);
  if (related.length === 0) return null;

  return (
    <section className="ss-section">
      <div className="ss-section__head">
        <h2>You might also like</h2>
      </div>
      <div className="ss-product-grid">
        {related.map((p) => (
          <ProductCard key={p._id || p.id} product={p} />
        ))}
      </div>
    </section>
  );
}
